import { writable } from 'svelte/store';

export const path = writable(window.location.pathname);

export function navigate(to) {
    history.pushState(null, '', to);
    path.set(to);
    window.scrollTo(0, 0);
}

window.addEventListener('popstate', () => {
    path.set(window.location.pathname);
});
